module.exports = {"attributes":{"width":"15","height":"15","viewBox":"0 0 15 15","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M10 12a1 1 0 0 1-2 0V8c0-.2.1-.5.3-.7L13 2H2l4.7 5.3c.2.2.3.5.3.7v6a1 1 0 0 1-2 0V8.4l-4.5-5A2 2 0 0 1 2 0h11a2 2 0 0 1 1.5 3.3l-4.5 5V12z\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/filter.svg
// module id = 1409
// module chunks = 0